import { useEffect, useState } from 'react';

/**
 * BL-14: Non-blocking service worker update banner.
 *
 * Listens for the 'sw:update-available' custom event dispatched by main.tsx
 * when a new service worker version is ready. Renders a dismissible banner
 * instead of a blocking confirm() dialog.
 */
export function UpdateBanner() {
  const [reload, setReload] = useState<(() => void) | null>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      const custom = e as CustomEvent<{ reload: () => void }>;
      setReload(() => custom.detail.reload);
    };

    window.addEventListener('sw:update-available', handler);
    return () => window.removeEventListener('sw:update-available', handler);
  }, []);

  if (!reload) return null;

  return (
    <div
      role='alert'
      style={{
        position: 'fixed',
        bottom: '1rem',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#1E3A5F',
        color: '#fff',
        padding: '0.75rem 1.25rem',
        borderRadius: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        zIndex: 9999,
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        fontSize: '0.9rem',
      }}
    >
      <span>A new version of Planacle is available.</span>
      <button
        onClick={() => reload()}
        style={{
          background: '#2E6DA4',
          color: '#fff',
          border: 'none',
          borderRadius: '0.25rem',
          padding: '0.35rem 0.85rem',
          cursor: 'pointer',
          fontWeight: 600,
          fontSize: '0.875rem',
        }}
      >
        Reload
      </button>
      <button
        onClick={() => setReload(null)}
        aria-label='Dismiss'
        style={{
          background: 'transparent',
          color: '#A8C8E8',
          border: 'none',
          cursor: 'pointer',
          fontSize: '1.1rem',
          lineHeight: 1,
          padding: '0 0.2rem',
        }}
      >
        ×
      </button>
    </div>
  );
}
